import React from "react";
import { reduxForm } from "redux-form";
import { Form, Segment, Divider } from "semantic-ui-react";
import BotonGuardar from "../../shared/botones/BotonGuardar";
import Servicios from "./formularioInscripcion/Servicios";
import Observaciones from "./formularioInscripcion/Observaciones";
import Pago from "./formularioInscripcion/Pago";
import DatosPersonales from "./formularioInscripcion/DatosPersonales";
import DatosContacto from "./formularioInscripcion/DatosContacto";
import AMPA from "./formularioInscripcion/AMPA";
import FormaDePago from "./formularioInscripcion/FormaDePago";
import Legal from "./formularioInscripcion/Legal";

class FormularioInscripcion extends React.Component {
  state = {
    importe: 0,
    precioEscuela: 0,
    descuentoAmpa: 0,
    descuentoHermano: 0,
    visible: false
  };

  componentDidMount() {
    this.setState({ visible: true });
  }

  preSubmit = values => {
    values.iban = `${values.iban1} ${values.iban2} ${values.iban3} ${
      values.iban4
    } ${values.iban5} ${values.iban6}`;

    this.props.handleSubmit(values => this.props.action(values));
  };

  setDescuentoHermano = () =>
    this.setState({ descuentoHermano: this.props.precios.descuentoHermano });

  setPrecioEscuela = valor => this.setState({ precioEscuela: valor });

  render() {
    const { handleSubmit, reset, precios } = this.props;

    return (
      <Form>
        <DatosPersonales />
        <Divider section />
        <DatosContacto />
        <Divider section />
        <Servicios
          setPrecioEscuela={this.setPrecioEscuela}
          precios={this.props.precios}
          colegio={this.props.colegio}
          provincia={
            this.props.provincia ? this.props.provincia.toUpperCase() : ""
          }
        />
        <Divider section />
        <AMPA precios={precios} />
        <Divider section />
        <Observaciones />
        <Divider section />
        <FormaDePago />
        <Divider section />
        <Pago />
        <Divider section />
        <Legal />

        <Divider section />
        <Segment basic padded="very">
          <BotonGuardar
            floated="right"
            buttonText="Confirmar"
            color="green"
            icon="checkmark"
            action={handleSubmit(values => this.props.confirmar(values))}
          />
          <BotonGuardar
            floated="right"
            icon="checkmark"
            action={handleSubmit(values => this.props.guardarCambios(values))}
          />
          <BotonGuardar
            basic
            floated="right"
            buttonText="Descartar Cambios"
            icon="cancel"
            action={reset}
          />
        </Segment>

        <Divider section />
      </Form>
    );
  }
}

export default reduxForm({ form: "FormularioAlumno" })(FormularioInscripcion);



// WEBPACK FOOTER //
// ./src/pages/preinscripciones/hojaPreinscripcion/FormularioInscripcion.jsx